import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import { books } from "../data/katha/catalog";
import { BookCard } from "../pages/KathaExperience";
import "../pages/KathaExperience.css";

export default function KathaShowcase() {
  return (
    <section className="katha-page katha-shelf-section" aria-label="लोकप्रिय हिंदी कथा पुस्तकें">
      <Container>
        <div className="katha-section-header"><div><span className="katha-eyebrow">✦ हमारी विशेष प्रस्तुति</span><h2>हिंदी कथाओं का डिजिटल पुस्तकालय</h2><p>श्रीकृष्ण, श्रीराम और महादेव की शिक्षाप्रद कथाएँ पढ़िए।</p></div><Link className="katha-secondary-link" to="/katha/">सभी पुस्तकें देखें <ArrowRight size={18}/></Link></div>
        <Row className="g-4">{books.slice(0,3).map(book => <Col key={book.slug} md={6} lg={4}><BookCard book={book}/></Col>)}</Row>
      </Container>
    </section>
  );
}
